<template>
	<div class="m-list-view flex-grow flex-column">
		<topbar v-if="topbar" ref="topbar" :search="search" :filter="!!$slots.filter" :work-type="customView ? '' : workType" :custom-view="customView" @update="topbarHandle" @empty="state => emptyState = state">
			<template #filter>
				<slot name="filter"></slot>
			</template>
		</topbar>

		<c-empty v-if="emptyState" message="暂无可用视图，请联系管理员处理"></c-empty>

		<c-scroll-list ref="list" class="flex-grow" :head-height="headHeight">
			<template #head>
				<slot name="head"></slot>
			</template>

			<template #default="{data, index}">
				<slot :index="index" :data="data"></slot>
			</template>
		</c-scroll-list>
	</div>
</template>

<script>
	import {createStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'viewList',

		props: {
			topbar: {
				type: Boolean,
				default: true
			},
			workType: [String, Number],
			viewId: [String, Number],
			customView: Object,
			search: {
				type: [Boolean, Object],
				default: true
			},
			headHeight: [Number, String],
			immediate: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				viewStore: createStore({
					fieldList: []
				}),
				coverField: null,
				titleField: null,
				countField: null,
				emptyState: false
			}
		},

		computed: {
			dataUrl() {
				return {
					1: '/aftersale/apply/list',        	// 售后申请单列表
					2: '/after/sale/order/list',        // 工单列表
					7: '/asset_receive_apply/list',    	// 资产领用列表
					9: '/outsource/recruit/list',    	// 外协招工列表
					11: '/expense/reimbursement/list', 	// 报销单列表
					12: '/leave/application/list',     	// 请假单列表
					13: '/asset_return_apply/list',  	// 资产归还列表
					14: '/overtime/application/list',  	// 加班申请列表
					16: '/asset_repair_record/list',  	// 资产维修列表
				}[this.workType]
			}
		},

		mounted() {
			this.immediate && this.load();

			new Promise(resolve => {
				if (!this.customView) {
					this.request({
						url: '/sys_app_view/field_config',
						data: {
							view_id: this.viewId
						},
						success: data => {
							this.coverField = data.cover_field;
							this.titleField = data.title_field_list || [];
							this.countField = data.count_field;
							this.viewStore.commit('fieldList', data.field_list);
							resolve();
						}
					});
				} else {
					resolve();
				}
			}).then(() => {
				this._fieldComplete = true;
				this.loadData();
			})
			
			this.$onShow(() => {
				this.$refs.list.update();
			});
		},

		activated() {
			if (this._deactivated) {
				delete this._deactivated;
				this.$refs.list.update();
			}
		},

		deactivated() {
			this._deactivated = true;
		},

		methods: {
			load(param) {
				this._parentComplete = true;
				this._parentParam = param;
				this.loadData();
			},

			topbarHandle() {
				this._topbarComplete = true;
				this.loadData();
			},

			loadData() {
				if (!this.dataUrl) return;
				if (!this._parentComplete || (this.topbar && !this._topbarComplete) || !this._fieldComplete) return;
				this.$refs.list && this.$refs.list.load({
					url: this.dataUrl,
					data: Object.assign({}, this.topbar ? this.$refs.topbar.params : {view_id: this.viewId}, this._parentParam),
					dataFormatter: data => {
						return !this.customView ? data.map(data => {
							data.baseInfo = {
								cover: (() => {
									let value = this.coverField ? this.coverField.is_custom == 1 ? data.customFieldValues[this.coverField.field_code].value : data[this.coverField.field_code] : null;
									if (value && typeof value == 'string') {
										value = value.split(',');
									}
									return value ? value[0] : null;
								})(),
								title: this.titleField.map(item => {
									return item.is_custom == 1 ? data.customFieldValues[item.field_code].value : data[item.field_code];
								}).filter(item => item !== undefined && item !== null && item !== '').join(' | ').replace(/( \| )+/g, ' | ').replace(/\s\|\s$/, ''),
								count: this.countField ? {
									name: this.countField.field_title,
									value: this.countField.is_custom == 1 ? data.customFieldValues[this.countField.field_code].value : data[this.countField.field_code]
								} : null
							}
							return data;
						}) : data;
					}
				});
				this.topbar && this.$refs.topbar && this.$refs.topbar.updateTabTotal(this.dataUrl);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-list-view {
		>>> .card {
			margin-top: .24rem;
		}
	}
</style>
